var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEyeOff(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_329_13192)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.52 5.93407L1.393 2.80807L2.808 1.39307L22.607 21.1931L21.192 22.6071L17.882 19.2971C16.1232 20.4126 14.0827 21.0034 12 21.0001C6.608 21.0001 2.122 17.1201 1.181 12.0001C1.61103 9.67078 2.78263 7.54296 4.521 5.93407H4.52ZM14.757 16.1721L13.293 14.7081C12.733 14.976 12.1038 15.0636 11.4919 14.9589C10.8801 14.8541 10.3158 14.5621 9.87687 14.1232C9.43794 13.6843 9.14597 13.12 9.04122 12.5081C8.93646 11.8963 9.02408 11.267 9.292 10.7071L7.828 9.24307C7.19172 10.2046 6.90727 11.3564 7.02283 12.5036C7.13839 13.6507 7.64685 14.7227 8.46212 15.5379C9.27739 16.3532 10.3494 16.8617 11.4965 16.9772C12.6437 17.0928 13.7955 16.8084 14.757 16.1721ZM7.974 3.76007C9.221 3.27007 10.58 3.00007 12 3.00007C17.392 3.00007 21.878 6.88007 22.819 12.0001C22.5126 13.6658 21.8239 15.2376 20.807 16.5921L16.947 12.7321C17.0617 11.9597 16.9938 11.1712 16.7489 10.4297C16.504 9.68827 16.0889 9.01448 15.5367 8.46233C14.9846 7.91019 14.3108 7.49504 13.5693 7.25014C12.8279 7.00524 12.0394 6.93741 11.267 7.05207L7.974 3.76107V3.76007Z",
    fill: "#1E1E1E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_329_13192"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOff);
export default __webpack_public_path__ + "static/media/eye-off.025439bf0d7f137f9b3f99878546b1ad.svg";
export { ForwardRef as ReactComponent };